<div id="step_bar">
    <span class="step" *ngFor="let i of [1,2,3,4,5,6,7,8]" [ngClass]="{'active':step === i,'finish':i < step}">{{i}}</span>
</div>
